import {
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var ClientConfigClass;
function ClientConfig() {
  if (ClientConfigClass === VOID) {
    class $ {
      constructor(prereleaseMode, auth0ClientId, auth0Domain, basename, expressEnv, webpackPublicPath, websocketHost) {
        this.w7b_1 = prereleaseMode;
        this.x7b_1 = auth0ClientId;
        this.y7b_1 = auth0Domain;
        this.z7b_1 = basename;
        this.a7c_1 = expressEnv;
        this.b7c_1 = webpackPublicPath;
        this.c7c_1 = websocketHost;
      }
      toString() {
        return 'ClientConfig(prereleaseMode=' + this.w7b_1 + ', auth0ClientId=' + this.x7b_1 + ', auth0Domain=' + this.y7b_1 + ', basename=' + this.z7b_1 + ', expressEnv=' + this.a7c_1 + ', webpackPublicPath=' + this.b7c_1 + ', websocketHost=' + this.c7c_1 + ')';
      }
      hashCode() {
        var result = getBooleanHashCode(this.w7b_1);
        result = imul(result, 31) + getStringHashCode(this.x7b_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.y7b_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.z7b_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.a7c_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.b7c_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.c7c_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ClientConfig()))
          return false;
        if (!(this.w7b_1 === other.w7b_1))
          return false;
        if (!(this.x7b_1 === other.x7b_1))
          return false;
        if (!(this.y7b_1 === other.y7b_1))
          return false;
        if (!(this.z7b_1 === other.z7b_1))
          return false;
        if (!(this.a7c_1 === other.a7c_1))
          return false;
        if (!(this.b7c_1 === other.b7c_1))
          return false;
        if (!(this.c7c_1 === other.c7c_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ClientConfig');
    ClientConfigClass = $;
  }
  return ClientConfigClass;
}
//region block: exports
export {
  ClientConfig as ClientConfig2mpft8d5d0hh3,
};
//endregion

//# sourceMappingURL=ClientConfig.mjs.map
